import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Row, Col, DatePicker, TimePicker, Select } from 'antd';

const PdfFilterModal = ({
    show,
    handleClose,
    pdfFilters,
    setPdfFilters,
    deviceOptions,
    isLoadingDevices,
    handleSelectChangePdf,
    descargarPDFDirecto,
    selectableColumns
}) => {
    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-lg modal-dialog-centered">
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold" style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif' }}>
                    Configurar Reporte PDF
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <p className="fw-bold">Rango de Fechas</p>
                        <DatePicker className="w-100 mb-2" placeholder="Fecha Inicio" format="DD/MM/YYYY" value={pdfFilters.fechaInicioPdf} onChange={(date) => setPdfFilters({ ...pdfFilters, fechaInicioPdf: date })} getPopupContainer={trigger => trigger.parentElement} />
                        <DatePicker className="w-100" placeholder="Fecha Fin" format="DD/MM/YYYY" value={pdfFilters.fechaFinPdf} onChange={(date) => setPdfFilters({ ...pdfFilters, fechaFinPdf: date })} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={12}>
                        <p className="fw-bold">Rango de Horas</p>
                        <TimePicker className="w-100 mb-2" placeholder="Hora Inicio" format="HH:mm" value={pdfFilters.horaInicioPdf} onChange={(time) => setPdfFilters({ ...pdfFilters, horaInicioPdf: time })} getPopupContainer={trigger => trigger.parentElement} />
                        <TimePicker className="w-100" placeholder="Hora Fin" format="HH:mm" value={pdfFilters.horaFinPdf} onChange={(time) => setPdfFilters({ ...pdfFilters, horaFinPdf: time })} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="mt-3">
                    <Col span={12}>
                        <p className="fw-bold">Terminales</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder={isLoadingDevices ? "Cargando..." : "Todas las terminales"} value={pdfFilters.devicesPdf} onChange={(value) => handleSelectChangePdf(value, "devicesPdf")} options={deviceOptions} disabled={isLoadingDevices} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={12}>
                        <p className="fw-bold">Tarjetas</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Todas las tarjetas" value={pdfFilters.tarjetasPdf} onChange={(value) => handleSelectChangePdf(value, "tarjetasPdf")} options={[{ value: "Visa", label: "Visa" }, { value: "MasterCard", label: "MasterCard" }, { value: "American Express", label: "American Express" }, { value: "Carnet", label: "Carnet" }, { value: "Sodexo", label: "Sodexo" }, { value: "SiVale", label: "SiVale" }, { value: "Edenred", label: "Edenred" }, { value: "Monedero", label: "Monedero" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="mt-3">
                    <Col span={8}>
                        <p className="fw-bold">Tipo</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Ambos" value={pdfFilters.tipoPdf} onChange={(value) => handleSelectChangePdf(value, "tipoPdf")} options={[{ value: "DEBIT", label: "Debito" }, { value: "CREDIT", label: "Credito" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={8}>
                        <p className="fw-bold">Estado</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Todos" value={pdfFilters.estadoPdf} onChange={(value) => handleSelectChangePdf(value, "estadoPdf")} options={[{ value: "Aprobada", label: "Aprobada" }, { value: "Rechazada", label: "Rechazada" }, { value: "Devolucion", label: "Devolucion" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={8}>
                        <p className="fw-bold">Propinas</p>
                        <Select mode="multiple" className="w-100" placeholder="Ambas" value={pdfFilters.propinasPdf} onChange={(value) => handleSelectChangePdf(value, "propinasPdf")} options={[{ value: "con_propina", label: "Con Propina" }, { value: "sin_propina", label: "Sin Propina" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
                <div className="mt-3">
                    <p className="fw-bold">Columnas a incluir</p>
                    <Select mode="multiple" className="w-100" placeholder="Todas las columnas" value={pdfFilters.selectedPdfColumns} onChange={(value) => setPdfFilters({ ...pdfFilters, selectedPdfColumns: value })} options={selectableColumns.map(col => ({ value: col.key, label: col.label }))} getPopupContainer={trigger => trigger.parentElement} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setPdfFilters({ ...pdfFilters, selectedPdfColumns: [] })} className="fw-bold" style={{ borderRadius: '20px' }}>Limpiar Columnas</Button>
                <Button variant="success" onClick={descargarPDFDirecto} className="fw-bold" style={{ borderRadius: '20px' }}>Generar PDF</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PdfFilterModal;
